<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="E.M.O" key="1">
        <g-master name="forms"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  ref="master"
                  @action="masterAction"
                  modalWidth="95%"
                  @params="paramsTable"
        >
          <template slot="customButton">
            <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
          </template>
          <span slot="estadoRenderer" slot-scope="{text}">
                        <a-tag
                          :color="text==='CERRADO' ? 'red' : (text === 'ABIERTO' ? 'blue' : 'blue')">{{text}}</a-tag>
          </span>
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Trabajador')"
                          :formItemConfig="fiOptions"
                          endpoint="personas"
                          ref="trabajador"
                          :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                >
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('IPS')"
                            ref="ipsList"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['ips', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                            :params="id_h_ips"
                >
                </g-dropdown>
              </a-col>
              <a-col v-if="mostrarOtraIps" v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('¿Cuál IPS?')">
                  <a-textarea style="width: 100%"
                              autoSize
                              v-decorator="['other_ips', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('Tipo EMO')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['emo_type', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                            :params="id_h_emo"
                >
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('P.V.E (Plan de Vigilancia Epidemiológica)')" :has-feedback="false">
                  <a-checkbox
                    v-decorator="['lifestyles', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                    Cardiovascular
                  </a-checkbox>
                  <a-checkbox
                    v-decorator="['osteomuscular', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                    Biomecánico
                  </a-checkbox>
                  <a-checkbox
                    v-decorator="['psychosocial', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                    Psicosocial
                  </a-checkbox>
                  <a-checkbox
                    v-decorator="['biological', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                    Biológico
                  </a-checkbox>
                  <a-checkbox
                    v-decorator="['visual', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                    Visual
                  </a-checkbox>
                  <a-checkbox
                    v-decorator="['hearing', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                    Auditivo
                  </a-checkbox>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions2" v-if="mostrarIMC">
                <g-dropdown :label="$t('Índice de Masa Corporal (IMC)')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['imc', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                            :params="lista_imc"
                >
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions2">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha Recomendaciones y/o Restricciones')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['recommendation_date', { rules: [{ required: false}] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions2">
                <a-form-item v-bind="fiOptions" :label="$t('Recomendaciones y/o Restricciones')">
                  <a-textarea style="width: 100%"
                              autoSize
                              v-decorator="['recommendations', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions2">
                <a-form-item v-bind="fiOptions" :label="$t('Compromiso')" :has-feedback="false">
                  <a-checkbox
                    v-decorator="['commitment', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                  </a-checkbox>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions2">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha Inicio')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['initial_date', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions2">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha Fin')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['end_date', { rules: [{ required: isRequiredFechaFin, message: 'Valor requerido'}] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions2">
                <g-lookup :label="$t('Responsable')"
                          ref="responsable_reintegro"
                          :formItemConfig="fiOptions"
                          endpoint="empleados"
                          :params="{filtra_por_cargo: true}"
                          :decorator="['responsable', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                >
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions2">
                <a-form-item v-bind="fiOptions" :label="$t('Obs. Seguimiento')">
                  <a-textarea style="width: 100%"
                              autoSize
                              v-decorator="['observations', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions2">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha de Remisión a EPS')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['remission_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions2">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha de Examen Medico')">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD 00:00:00"
                                 v-decorator="['occupational_medical_exam_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions2">
                <g-dropdown :label="$t('Concepto de Altura')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['height_concept', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                            :params="emo_concepto_altura"
                >
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions2">
                <g-dropdown :label="$t('Concepto de Aptitud')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['aptitude_concept', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                            :params="emo_concepto_aptitud"
                >
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions2">
                <g-dropdown :label="$t('Concepto Favorable por SIG')"
                            ref="conceptoSIGList"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['sig_concept', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                            :params="emo_concepto_sig"
                >
                </g-dropdown>
              </a-col>
              <a-col v-if="mostrarComenSIG" v-bind="colOptions2">
                <a-form-item v-bind="fiOptions" :label="$t('Si esta PENDIENTE describa por qué')">
                  <a-textarea style="width: 100%"
                              autoSize
                              v-decorator="['sig_comment', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions2">
                <g-dropdown :label="$t('Estado del Caso')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['close_case', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                            :params="estado_caso_emo"
                >
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions2">
                <a-form-item v-bind="fiOptions" :label="$t('Observaciones Generales')">
                  <a-textarea style="width: 100%"
                              autoSize
                              v-decorator="['general_remarks', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="DETALLES" key="2">
            <emo-details v-if="emoInfo" :emoInfo="emoInfo"></emo-details>
            <span v-else>Seleccione una registro para ver más.</span>
          </a-tab-pane>
        </a-tabs>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  export default {
    data () {
      return {
        isRequiredFechaFin: this.$getConfigValue('NOTIFICACIONES_EMO', 'NO') === 'SI',
        mostrarOtraIps: false,
        mostrarIMC: false,
        mostrarComenSIG: false,
        paramsT: {},
        endpointExcel: 'emo_/downloadExcel',
        fileNameExcel: 'EMO',
        estado_caso_emo: {
          h_lookup_type: 'EMO_ESTADO_CASO'
        },
        id_h_emo: {
          h_lookup_type: 'TIPO_EMO'
        },
        id_h_ips: {
          h_lookup_type: 'REINCORPORACIONES_IPS'
        },
        id_h_refund_type: {
          h_lookup_type: 'REINCORPORACIONES_TIPO_REINTEGRO'
        },
        id_h_status: {
          h_lookup_type: 'REINCORPORACIONES_ESTADO'
        },
        lista_imc: {
          h_lookup_type: 'IMC'
        },
        emo_concepto_altura: {
          h_lookup_type: 'EMO_CONCEPTO_DE_ALTURA'
        },
        emo_concepto_aptitud: {
          h_lookup_type: 'EMO_CONCEPTO_APTITUD'
        },
        emo_concepto_sig: {
          h_lookup_type: 'EMO_CONCEPTO_FAVORABLE_SIG'
        },
        fiOptions: {
          'label-col': {},
          'wrapper-col': {},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 12},
        colOptions2: {xs: 24, sm: 8},
        master: {
          endpoint: 'emo',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            customSlots: ['estadoRenderer'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Doc. Identidad Empleado', dataIndex: 'cedula_empleado', sorter: true},
              {title: 'Nombre del Empleado', dataIndex: 'nombre_completo_empleado', sorter: true},
              {title: 'Fecha Inicio Contrato', dataIndex: 'fecha_ingreso_trabajador', sorter: true},
              {title: 'Cargo', dataIndex: 'cargo_trabajador', sorter: true},
              {title: 'Puesto de Trabajo', dataIndex: 'desc_id_h_att_2', sorter: true},
              {
                title: 'Estado del Caso',
                dataIndex: 'close_case_desc',
                sorter: true,
                fixed: 'right',
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              }
            ]
          }
        }
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.mostrarOtraIps = false
            this.mostrarIMC = false
            this.mostrarComenSIG = false
            break
          case 'masterEdit':
            if (!JsUtils.isEmpty(action.record.id_emp)) {
              this.$refs.trabajador && this.$refs.trabajador.handleSearch(action.record.id_emp)
            }
            if (!JsUtils.isEmpty(action.record.responsable)) {
              this.$refs.responsable_reintegro && this.$refs.responsable_reintegro.handleSearch(action.record.responsable)
            }
            if (!JsUtils.isEmpty(action.record.lifestyles)) {
              this.mostrarIMC = action.record.lifestyles
            }
            if (!this.$isEmpty(action.record.codigo_ips)) {
              if (action.record.codigo_ips === 'OTR') {
                this.mostrarOtraIps = true
                setTimeout(() => {
                  this.$refs.master.modal.form.setFieldsValue({
                    other_ips: action.record.other_ips
                  })
                }, 300)
              } else {
                this.mostrarOtraIps = false
              }
            }
            if (!this.$isEmpty(action.record.con_sig_desc)) {
              if (action.record.con_sig_desc === 'PENDIENTE') {
                this.mostrarComenSIG = true
                setTimeout(() => {
                  this.$refs.master.modal.form.setFieldsValue({
                    sig_comment: action.record.sig_comment
                  })
                }, 300)
              } else {
                this.this.mostrarComenSIG = false
              }
            }
            break
          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }
            if (!this.$isEmpty(action.changedFields.ips)) {
              let valorSeleccionado = this.$refs.ipsList.options.filter(item => item.value === action.changedFields.ips.value)
              if (valorSeleccionado.length > 0) {
                let ips = valorSeleccionado[0]
                this.mostrarOtraIps = ips.code === 'OTR'
              } else {
                this.mostrarOtraIps = false
              }
            }
            if (!this.$isEmpty(action.changedFields.lifestyles)) {
              this.mostrarIMC = !!action.changedFields.lifestyles.value
            }
            if (!this.$isEmpty(action.changedFields.sig_concept)) {
              let valorSeleccionado = this.$refs.conceptoSIGList.options.filter(item => item.value === action.changedFields.sig_concept.value)
              if (valorSeleccionado.length > 0) {
                console.log(valorSeleccionado[0])
                let conceptoSIG = valorSeleccionado[0]
                this.mostrarComenSIG = conceptoSIG.code === 'PEN'
              } else {
                this.mostrarComenSIG = false
              }
            }
            break
        }
      }
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      },
      emoInfo () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/MatrizSeguimiento/EMO.vue